import * as React from 'react';
export const IcConstipation = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M8.08 9.19c0-.65-.45-1.19-1-1.19s-1 .53-1 1.19v4.75h2V9.19zm-2 5.76v.63c0 2.45 1.76 4.43 3.94 4.43h1.69c.31 0 .56-.28.56-.63v-.63h.56c1.24 0 2.25-1.13 2.25-2.53v-1.26h-9v-.01zm11.6-2.65a.773.773 0 00-.6-.29h-3.6l1.45-3.63a.994.994 0 00-.56-1.3.994.994 0 00-1.3.56l-2 5a.994.994 0 00.93 1.37h4.08v5.12c0 .48.43.88.96.88s.96-.39.96-.88v-6.19c0-.26-.13-.49-.33-.65l.01.01zm-1.17-5.29c.3 0 .59-.09.83-.25.25-.16.44-.4.55-.67.11-.27.14-.58.09-.87-.06-.29-.2-.56-.41-.77-.21-.21-.48-.35-.77-.41a1.45 1.45 0 00-.87.09c-.27.11-.51.31-.67.55a1.499 1.499 0 001.25 2.33z'
      fill='currentColor'
    />
  </svg>
);
